const Feedback = function(dispatcher, options) {

    this.popup = null;
    this.popupHelpUs = null;

    this.init = () => {
        if (typeof currentNode === "undefined") {
            return;
        }

        this.create();
        this.createBlankOverlay();
        if (feedbackHelpUsEnabled) {
            this.createHelpUs();
            this.openHelpUs();

            document.getElementById("feedback-help-us-cancel").addEventListener("click", (event) => {
                this.closeHelpUs();

                return false;
            });
            document.getElementById("feedback-help-us-ok").addEventListener("click", (event) => {
                this.open();
                this.closeHelpUs();

                return false;
            });
        }

        document.addEventListener("DOMContentLoaded", () => {
            document.body.addEventListener("click", function(event) {
                if (event.target.id === 'mainOverlay') {
                    this.closeWebPush();
                }
            }.bind(this));
        });

        const fb = document.getElementById("feedback")
        if (fb) {
            let listenForAnimationEnd = false;

            fb.addEventListener("mouseover", (event) => {
                listenForAnimationEnd = false;
                fb.classList.add('hover');
            });

            fb.addEventListener("mouseout", (event) => {
                listenForAnimationEnd = true;
            });

            fb.querySelector('#feedbackButton').addEventListener('animationiteration', (event) => {
                if (event.animationName === 'typing' && listenForAnimationEnd) {
                    fb.classList.remove('hover');
                    listenForAnimationEnd = false;
                }
            })
        }

        const fc = document.getElementById("feedback_click")
        if (fc) {
            fc.addEventListener("click", (event) => {
                this.closeHelpUs();
                this.open();

                return false;
            });
        }
        const fca = document.getElementById("feedback-cancel")
        if (fca) {
            fca.addEventListener("click", (event) => {
                this.close();

                return false;
            });
        }

        const fs = document.getElementById("feedback-send")
        if (fs) {
            fs.addEventListener("click", (event) => {
                this.send();

                return false;
            });
        }

        const inputs = document.getElementsByClassName("feedback-text");
        for (let i = 0; i < inputs.length; i++) {
            inputs[i].addEventListener("keyup", (event) => {
                if (this.isAnyTextFilled()) {
                    this.enableSendButton();
                } else {
                    this.disableSendButton();
                }
            });
        }
    }

    this.isAnyTextFilled = () => {
        return document.getElementById("feedback-like").value.trim().length > 0 ||
            document.getElementById("feedback-better").value.trim().length > 0 ||
            document.getElementById("feedback-add").value.trim().length > 0;
    }

    this.resetTexts = () => {
        document.getElementById("feedback-like").value = "";
        document.getElementById("feedback-better").value = "";
        document.getElementById("feedback-add").value = "";
    }

    this.send = () => {
        dispatcher.dispatch('dialog_waiting', {
            title: "Sending",
            body_text: "Sending"
        });

        const data = new FormData();
        data.append('like', document.getElementById("feedback-like").value);
        data.append('better', document.getElementById("feedback-better").value);
        data.append('add', document.getElementById("feedback-add").value);
        data.append('for', currentNode.label);

        const xhttp = new XMLHttpRequest();
        xhttp.open("POST", options.url_send + "/" + userId, true);
        xhttp.send(data);

        xhttp.onload = () => {
            dispatcher.dispatch('dialog_waiting-close');
            if (xhttp.readyState == 4 && xhttp.status == 200) {
                this.close();
                dispatcher.dispatch('dialog_notification', {
                    body: "Thank you for your feedback, it has been successfully submitted"
                });
            } else {
                dispatcher.dispatch('dialog_ok', {
                    title: "Error",
                    body: "There was an error while sending feedback"
                });
            }
        };
        xhttp.onerror = () => {
            dispatcher.dispatch('dialog_waiting-close');
            dispatcher.dispatch('dialog_ok', {
                title: "Error",
                body: "There was an error while sending feedback"
            });
        };
    }

    this.sendDoNotDisplay = () => {
        const xhttp = new XMLHttpRequest();
        xhttp.open("POST", options.url_do_not_display + "/" + userId, true);
        xhttp.send();
    }

    this.open = () => {
        this.popup.style.display = "";
        this.showOverlay();
        this.resetTexts();
        this.disableSendButton();
    }

    this.openHelpUs = () => {
        this.showOverlay();
        this.popupHelpUs.style.display = "";
    }

    this.closeHelpUs = () => {
        this.hideOverlay();
        if (!this.popupHelpUs) {
            return;
        }
        this.popupHelpUs.style.display = "none";
        const checkbox = document.getElementById("feedback-do-not-display")
        if (checkbox && checkbox.checked) {
            this.sendDoNotDisplay();
        }
    }

    this.disableSendButton = () => {
        document.getElementById("feedback-send").disabled = true;
    }

    this.enableSendButton = () => {
        document.getElementById("feedback-send").disabled = false;
    }

    this.close = () => {
        this.hideOverlay();
        this.popup.style.display = "none";
    }

    this.createBlankOverlay = () => {
        if (document.getElementById('mainOverlay') !== null) {
            return;
        }
        const overlayDiv = document.createElement("div");
        overlayDiv.setAttribute('id', 'mainOverlay');
        document.body.appendChild(overlayDiv);
    };

    this.showOverlay = () => {
        document.getElementById("mainOverlay").style.display = "block";
    };

    this.hideOverlay = () => {
        document.getElementById("mainOverlay").style.display = "none";
    };

    this.create = () => {
        this.popup = document.createElement("div");
        this.popup.setAttribute('id', 'feedBackPopup');

        this.popup.classList.add("feedback-popup", "modal-visible", "default-dialog");

        let html = `<div class='dialog-confirm-header'><span class="popup-label">Provide feedback</span><span class="label-icon"><i class="icon icon-comment"></i></span></div>
<div class='dialog-confirm-body'>
    <div>
        <p>Thank you for taking the time to send us your thoughts on this area of Adwanted Connected. All feedback is considered by our Product team for inclusion in our roadmap.</p>
    </div>
    <div class="feedback-section first-item">
        <p>Feedback for: <span id="currentFeedbackPage">${currentNode.label}</span></p>
    </div>
    <div class="feedback-section">
        <p>What do you like about this section of the app?</p>
        <textarea placeholder="Click here and start typing" class="feedback-text" id="feedback-like"></textarea>
    </div>
    <div class="feedback-section">
        <p>What do you think could be better?</p>
        <textarea placeholder="Click here and start typing" class="feedback-text" id="feedback-better"></textarea>
    </div>
    <div class="feedback-section">
        <p>Is there any data and/or functionality that is important to add?</p>
        <textarea placeholder="Click here and start typing" class="feedback-text" id="feedback-add"></textarea>
    </div>
</div>
<div class='dialog-confirm-footer'>
    <button class="dialog-confirm-ok" id="feedback-send">Submit</button>
    <button class="dialog-confirm-cancel" id="feedback-cancel">Cancel</button>
</div>`;
        this.popup.innerHTML = html;
        this.popup.style.display = "none";

        document.body.appendChild(this.popup);
    }

    this.createHelpUs = () => {
        this.popupHelpUs = document.createElement("div");
        this.popupHelpUs.setAttribute('id', 'helpUsPopup')
        this.popupHelpUs.classList.add("feedback-help-us-popup", "modal-visible", "default-dialog");

        let doNotDisplayBox = "";
        if (feedbackDoNotDisplayEnabled) {
            doNotDisplayBox = `<p id="disclaimer">Do not display this message again <input type="checkbox" id="feedback-do-not-display"/></p>`;
        }

        let html = `<div class='dialog-confirm-header'>Please help us to deliver more</div>
<div class='dialog-confirm-body'>
    <p>We are constantly striving to bring you new data, new functionality and a better experience. Your feedback is
    incredibly important to us and if you can spare a couple of minutes to tell us what you think, we will make sure that
    your comments are fed into our product development roadmap. You can provide feed by clicking the button below or any time
    you see the <span class="label-icon"><i class="icon icon-comment"></i></span> icon in the top-right hand corner of your screen. Thank you <span id="faceIcon">&#x263A; </span></p>
    ${doNotDisplayBox}
</div>
<div class='dialog-confirm-footer'>
    <button class="dialog-confirm-ok" id="feedback-help-us-ok">Provide feedback</button>
    <button class="dialog-confirm-cancel" id="feedback-help-us-cancel">Not now thanks</button>
</div>`;
        this.popupHelpUs.innerHTML = html;
        this.popupHelpUs.style.display = "none";

        document.body.appendChild(this.popupHelpUs);
    }
};

export { Feedback }
